import { useQuery } from '@tanstack/react-query';
import { getFeatureFlags } from '@/apis/featureFlags';

export function useFeatureFlags(orgUUID: string) {
  const { data, isLoading } = useQuery({
    queryKey: ['featureFlags', orgUUID],
    queryFn: () => getFeatureFlags(orgUUID),
    enabled: !!orgUUID,
    staleTime: 5 * 60 * 1000,
  });

  return {
    features: data?.Features ?? {},
    isLoading,
    isEnabled: (flag: string) => data?.Features[flag] === true,
  };
}
